<template>
  <div v-if="show">
    <!-- 微信登录 绑定手机号 -->
    <div v-if="isWx && uid == '0'">
      <div class="login login-shadow">
        <!-- <img @click="close" src="@/assets/img/dianbo/close.png" alt /> -->
      </div>
      <div class="login login-box">
        <div class="title">请登录</div>
        <div class="phone input-box">
          <input type="text" placeholder="手机号" v-model="mobile" />
        </div>
        <div class="code input-box">
          <input type="text" placeholder="验证码" v-model="verifycode" />
          <span @click="sendCode">{{codeText}}</span>
        </div>
        <div class="login-btn canpress" @click="login">提交</div>
      </div>
    </div>

    <div v-else>
      <div class="login login-shadow">
        
      </div>
      <div class="login login-box">
        <img class="img-close" @click="close" src="@/assets/img/base/close.png" alt />
        <div class="title">登录</div>
        <div class="phone input-box">
          <input type="text" placeholder="手机号" v-model="mobile" />
        </div>
        <div class="code input-box">
          <input type="text" placeholder="验证码" v-model="verifycode" />
          <span @click="sendCode">{{codeText}}</span>
        </div>
        <div v-show="mobile&&verifycode" class="login-btn canpress" @click="login">登录</div>
        <div v-show="!(mobile&&verifycode)" class="login-btn" >登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import Http from "utils/fetchDefault/fetch";
import initCompate from "utils/compatibility"
import {
  DEFAULT_SENDRANDOMCODE,
  DEFAULT_LOGIN_BY_VCODE,
  OAUTH2_TOKEN,
  WX_ACCESSTOKEN,
  DEFAULT_WX_REGISTER,
  DEFAULT_SEND_REG_RANDOM_CODE
} from "utils/api";
import hex_md5 from "utils/md5";
import Cookie from "utils/cookie";
import { Toast } from 'vant'
export default {
  name: "login",
  // props: ["show"],
  data() {
    return {
      //登录
      show: false,
      isWx: false,
      mobile: "",
      verifycode: "",
      codeText: "发送验证码",
      openId: "",
      uid: "",
      loginInfo: {},
      callback:null,
    };
  },
  created() {
    this.isWx = this.isWeixin();

    //  临时兼容 微信端注册验证码问题 
    // this.isWx = false;
    
    // var loginInfo = localStorage["loginInfo"];
    // if(!loginInfo){
    //   this.getToken()
    // }
  },
  mounted() {
    // if (this.getCode() && this.isWx) {
    //   this.wxLogin();
    // }
    
    
  },
  methods: {
    showLoginBox(){
      this.show = true;
      setTimeout(() =>{
        initCompate();
      },300)
      
    },
    async toLogin(callback,isCloseWxLg) {
      this.callback = callback;
      //需要登录时调用此方法  登录信息将保存到 localStorage["loginInfo"]
      const flag = await this.checkIsLogin(isCloseWxLg)
      if(!flag){

        if (this.isWx&&!isCloseWxLg) {
          this.wxLogin();
        } else {
          this.isWx = false
          this.showLoginBox()
        }
      }
      
    },
    inApp(){
        var ua = navigator.userAgent.toLowerCase()
        if(ua.indexOf('gkztc')> -1){
            return true
        }else{
            return false
        }
    },
    async checkIsLogin(isCloseWxLg) {

      //需要检验是否登录调用此方法
      var loginInfo = localStorage["loginInfo"];
      var uid = localStorage["uid"];
      if(!isCloseWxLg&&this.isWx){
        var openid = Cookie.getCookie("openId");
        if(!openid){
          console.log('openid nono')
          return false
        }
      }
      console.log('checkIsLogin', loginInfo, uid>0, loginInfo && uid>0)
      if (loginInfo && uid>0) {
        // 如果是App，有登录信息就不再判断过期。因为没法刷新
        if (this.inApp()) {
          return true
        }
        loginInfo = JSON.parse(loginInfo);
        // console.log(loginInfo);
        var time = parseInt(new Date().getTime() / 1000);
        console.log(time < loginInfo.expires_in + 24 * 60 * 60)
        if (time < loginInfo.expires_in + 24 * 60 * 60) {
          await this.refreshToken(loginInfo.refresh_token)
          return true;
        }
        return false;
      } else {
        return false;
      }
    },
    refreshToken(refresh_token) { //刷新token

      var uid = localStorage["uid"];
      return Http.post(OAUTH2_TOKEN, {
        client_id: "gkztcweb",
        client_secret: "web4gkztc",
        grant_type: "refresh_token",
        uid: uid,
        refresh_token: refresh_token
      }).then(res => {
        if (res.code == 0) {
          // callback(res.data.access_token);
          var data = res.data
           data.expires_in =
            parseInt(new Date().getTime() / 1000) + res.data.expires_in;
          this.loginInfo = data;
          localStorage["loginInfo"] = JSON.stringify(data);
          // debugger
          this.callback&&this.callback();
          this.callback = null
          return Promise.resolve()
        }
      });
    },
    isWeixin() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.indexOf("micromessenger") != -1;
    },
    close() {
      this.show = false;
    },
    randomString(len) {
      len = len || 42;
      var $chars =
        "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
      var maxPos = $chars.length;
      var pwd = "";
      for (var i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    // 验证码登录
    login() {
      if (this.mobile == "" || this.mobile.trim().length != 11) {
        alert("请输入11位的手机号");
        return;
      }
      if (this.verifycode == "") {
        alert("请输入验证码");
        return;
      }
      if (this.isWx) {
        var data = {
          // access_token: this.loginInfo.access_token,
          openid: this.openId,
          verifycode: this.verifycode,
          mobile: this.mobile
        };
        // console.log(data);
        // this.uploading = this.$loading({
        //     background: 'rgba(0, 0, 0, 0.6)'
        // })
        Toast.loading({
          duration: 0,
          message: "加载中...",
          forbidClick: true,
          className: 'login-toast'
        });
        Http.post(DEFAULT_WX_REGISTER, data).then(res => {
          // console.log("register", res);
          // this.uploading.close()
          if (res.code == 0) {
            Toast.clear()
            this.show = false;
            localStorage['userInfo'] = JSON.stringify(res.data.item)
            localStorage['uid'] = res.data.item.id
            this.$message({
              type:'success',
              message: "绑定成功"
            });
            this.callback&&this.callback();
            this.callback = null
          }
        }).catch(error=>{
          // this.uploading.close()
        });
      } else {
        var data = {
          access_token: this.loginInfo.access_token,
          verifycode: this.verifycode,
          ostype: "0", //（0默认1安卓2苹果3web4微信5小程序）
          mobile: this.mobile
        };
        // this.uploading = this.$loading({
        //     background: 'rgba(0, 0, 0, 0.6)'
        // })
        Toast.loading({
          duration: 0,
          message: "加载中...",
          forbidClick: true,
          className: 'login-toast'
        });
        Http.post(DEFAULT_LOGIN_BY_VCODE, data).then(res => {
          // console.log(res);
          // this.uploading.close()
          if (res.code == 0) { 
            Toast.clear()
            this.show = false;
            
            const data = res.token
            data.expires_in = parseInt(new Date().getTime() / 1000) + res.token.expires_in;
            // this.$store.commit("setLoginInfo", data);
            this.loginInfo = data


            localStorage['userInfo'] = JSON.stringify(res.data.item)
            localStorage['uid'] = res.data.uid
            localStorage["loginInfo"] = JSON.stringify(this.loginInfo);
            this.$message({
              type:'success',
              message: "登录成功"
            });
            this.callback&&this.callback();
            this.callback = null
          }
        }).catch(error=>{
          // this.uploading.close()
        });
      }
    },
    sendCode() {
      if (this.codeText != "发送验证码") {
        return;
      }
      if (this.mobile == "" || this.mobile.trim().length != 11) {
        alert("请输入11位的手机号");
        return;
      }
      if (this.isWx) {
        var data = {
          // access_token: this.loginInfo.access_token,
          mobile: this.mobile,
          type: 1,
          category: 1,
          // ver: 1.1,
          // chksign: hex_md5(
          //   this.loginInfo.access_token + "g2k0z1t0c" + this.mobile
          // )
        };
        // console.log(data);
        //  this.uploading = this.$loading({
        //   background: 'rgba(0, 0, 0, 0.6)'
        // })
        Toast.loading({
          duration: 0,
          message: "加载中...",
          forbidClick: true,
          className: 'login-toast'
        });
        Http.post(DEFAULT_SENDRANDOMCODE, data).then(res => {
          // console.log(res);
          // this.uploading.close()
          if (res.code == 0) {
            Toast.clear()
            var count = 60;
            this.codeText = "还有" + count + "秒";
            var timer = setInterval(() => {
              count--;
              if (count == 0) {
                this.codeText = "发送验证码";
                clearInterval(timer);
              } else {
                this.codeText = "还有" + count + "秒";
              }
            }, 1000);
          }
        }).catch(error=>{
          // this.uploading.close()
        });
      } else {
        this.sendRandomCode()
        // this.getLoginInfo(this.sendRandomCode);

        // var data = {
        //   access_token: access_token,
        //   mobile: this.mobile,
        //   type: "1", //1短信 2语音
        //   category: "13", //1注册2忘记密码11身份验证 12手机号变更13验证码登录）
        //   ver: "1",
        //   chksign: hex_md5(this.randomString() + "g2k0z1t0c" + this.mobile) //MD5加密后的字段 ($access_token + 'g2k0z1t0c' + $mobile)
        // };
        // Http.post(DEFAULT_SENDRANDOMCODE, data).then(res => {
        //   console.log(res);
        //   if (res.code == 0) {
        //     var count = 60;
        //     this.codeText = "还有" + count + "秒";
        //     var timer = setInterval(() => {
        //       count--;
        //       if (count == 0) {
        //         this.codeText = "发送验证码";
        //         clearInterval(timer);
        //       } else {
        //         this.codeText = "还有" + count + "秒";
        //       }
        //     }, 1000);
        //   }
        // });
      }
    },
    sendRandomCode(loginInfo) {
      // this.uploading = this.$loading({
      //   background: 'rgba(0, 0, 0, 0.6)'
      // })
      Toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true,
        className: 'login-toast'
      });
      var data = {
        // access_token: loginInfo.access_token,
        mobile: this.mobile,
        type: "1", //1短信 2语音
        category: "13", //1注册2忘记密码11身份验证 12手机号变更13验证码登录）
        ver: "1",
        // chksign: hex_md5(loginInfo.access_token + "g2k0z1t0c" + this.mobile) //MD5加密后的字段 ($access_token + 'g2k0z1t0c' + $mobile)
      };
      Http.post(DEFAULT_SENDRANDOMCODE, data).then(res => {
        // console.log(res);
        // this.uploading.close();
        if (res.code == 0) {
          Toast.clear()
          var count = 60;
          this.codeText = "还有" + count + "秒";
          var timer = setInterval(() => {
            count--;
            if (count == 0) {
              this.codeText = "发送验证码";
              clearInterval(timer);
            } else {
              this.codeText = "还有" + count + "秒";
            }
          }, 1000);
        }
      }).catch(error=>{
        // this.uploading.close();
      });
    },
    getLoginInfo(callback) {
      Http.post(OAUTH2_TOKEN, {
        client_id: "gkztcweb",
        client_secret: "web4gkztc",
        grant_type: "client_credentials",
        uid: "",
        refresh_token: ""
      }).then(res => {
        if (res.code == 0) {
          var data = res.data;
          data.expires_in =
            parseInt(new Date().getTime() / 1000) + res.data.expires_in;
          this.loginInfo = data;
          // localStorage["loginInfo"] = JSON.stringify(data);
          // callback(res.data.access_token,this.getCode());
          callback(data);
        }
      });
    },

    // 微信授权登录
    wxLogin() {
      if (!this.checkExpires()) {
        // this.getToken(this.checkCode)
        this.checkCode();
      } else {
        console.log("你已经登录过了");
      }
      // this.getToken(this.checkCode);
    },

    checkExpires() {
      var openid = Cookie.getCookie("openId");
      if (!openid) {
        return false;
      }
      var loginInfo = localStorage["loginInfo"];
      var uid = localStorage["uid"];
      if (loginInfo&&uid>0) {
        loginInfo = JSON.parse(localStorage["loginInfo"]);
        this.loginInfo = loginInfo;
        // console.log("loginInfo", loginInfo);
        var dateTime = parseInt(new Date().getTime() / 1000);
        if (dateTime < loginInfo.expires_in) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    // function getOpenid(){
    //     const oid = Cookie.getCookie("openId");
    //     if(oid==="")  return false;
    //     return oid;
    // }
    checkCode() {
      if (this.getCode()) {
        console.log("hascode");
        // this.getToken(this.getWxToken);
        this.getWxToken(this.getCode())
        // this.getWxToken(token, this.getCode());
      } else {
        console.log("nocode");
        this.getWxcode();
      }
    },

    getWxToken(code) {
      var _this = this;
      console.log(code);
      Http.post(WX_ACCESSTOKEN, {
        // access_token: token,
        code: code
      }).then(res => {
        if (res.code == 0) {
          var data = res.data;
          // console.log("data", data);
          var token = res.token
          token.expires_in = parseInt(new Date().getTime() / 1000) + res.token.expires_in;
          // this.$store.commit("setLoginInfo", data);
          this.loginInfo = token
          localStorage["loginInfo"] = JSON.stringify(token);

          if (data.openid) {
            Cookie.setCookie("openId", data.openid);
            _this.openId = data.openid;
          }
          if (data.uid) {
            Cookie.setCookie("uid", data.uid);
            localStorage['uid'] = data.uid;
          }
          _this.uid = data.uid;
          // _this.uid = 0;
          console.log("uiduid", _this.uid);
          if (_this.uid == "0") {
            _this.showLoginBox()
          }else{
            this.callback&&this.callback();
            this.callback = null
          }
          
        } else {
          this.getWxcode();
        }
      });
    },
    // 去掉url某个参数
    removeURLParameter(url, parameter) {
      var urlparts = url.split('?');
      if(urlparts.length >= 2) {
        //参数名前缀
        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);
    
        //循环查找匹配参数
        for(var i = pars.length; i-- > 0;) {
          if(pars[i].lastIndexOf(prefix, 0) !== -1) {
            //存在则删除
            pars.splice(i, 1);
          }
        }
    
        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
      }
      return url;
    },
    getWxcode() {
      let href = window.encodeURI(this.removeURLParameter(window.location.href, 'code'));
      let newurl = window.location.pathname + window.location.search;
      var appid = "wxa4d612a11ba4e9b8";

      window.location.href = `https://app.gaokaozhitongche.com/wx/index?appid=${appid}&redirect_uri=${href}&response_type=code&scope=snsapi_base&state=${newurl}#wechat_redirect`;

      // var openid = Cookie.getCookie('openId')
      // console.log('openid',openid)
      // if(openid){
      //   window.location.href = `https://app.gaokaozhitongche.com/wx/index?appid=${appid}&redirect_uri=${href}&response_type=code&scope=snsapi_base&state=${newurl}#wechat_redirect`;
      // }else{
      //   window.location.href = `https://app.gaokaozhitongche.com/wx/index?appid=${appid}&redirect_uri=${href}&response_type=code&scope=snsapi_userinfo&state=${newurl}#wechat_redirect`;
      // }
    },

    getCode() {
      if (!window.location.search) return false;
      let query = window.location.search.split("?")[1].split("&");
      for (let x in query) {
        if (query[x].indexOf("=") === -1) continue;
        if (query[x].split("=")[0] === "code") return query[x].split("=")[1];
      }
      return false;
    },

    getToken(callback) {
      Http.post(OAUTH2_TOKEN, {
        client_id: "gkztcweb",
        client_secret: "web4gkztc",
        grant_type: "client_credentials",
        uid: "",
        refresh_token: ""
      }).then(res => {
        if (res.code == 0) {
          var data = res.data;
          data.expires_in =
            parseInt(new Date().getTime() / 1000) + res.data.expires_in;
          this.loginInfo = data;
          localStorage["loginInfo"] = JSON.stringify(data);
          callback&&callback(res.data.access_token, this.getCode());
        }
      });
    }
  }
};
</script>
<style lang="scss">
.el-loading-mask{
  // z-index: 999999!important;
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
// 登录
.login-shadow {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  max-width: 768px;
  background: #000;
  opacity: 0.6;
  z-index: 9999;
  
}
.login-box {
  width: 16rem;
  height: 11rem;
  border-radius: 0.5rem;
  background: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;
  .img-close {
    display: block;
    width: 1.5rem;
    height: 1.5rem;
    position: absolute;
    right: 0;
    top: -2rem;
  }
  .title {
    width: 100%;
    text-align: center;
    line-height: 2rem;
    margin-bottom: 0.5rem;
    color: #333;
    font-size: 0.8rem;
  }
  .input-box {
    width: 14rem;
    height: 2rem;
    margin: 0 auto;
    position: relative;
    line-height: 2rem;
    margin-bottom: 0.5rem;
    border-bottom: 1px solid #ccc;
    span {
      display: block;
      width: 4.6rem;
      height: 1.5rem;
      font-size: 0.65rem;
      line-height: 1.5rem;
      text-align: center;
      border: 1px solid #ccc;
      border-radius: 0.3rem;
      position: absolute;
      right: 0;
      top: 0.25rem;
    }
  }
  input {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
    outline: 0;
    text-align: left;
    font-size: 0.65rem;
    color: #666;
  }
  .login-btn {
    width: 14rem;
    height: 2rem;
    margin: 0 auto;
    font-size: 0.75rem;
    line-height: 2rem;
    text-align: center;
    color: #fff;
    background: #2382ff;
    border-radius: 1rem;
    margin-top: 1rem;
    opacity: 0.5;
  }
  .canpress{
    opacity: 1;
  }
}
</style>
